import React, { createContext, useContext, useState } from 'react';

const WorkspaceContext = createContext();

export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};

export const WorkspaceProvider = ({ children }) => {
  const [currentWorkspace, setCurrentWorkspace] = useState({
    id: 'personal',
    name: 'Personal Workspace',
    type: 'personal',
    icon: '👤'
  });

  const [workspaces] = useState([
    { id: 'personal', name: 'Personal Workspace', type: 'personal', icon: '👤' },
    { id: 'firm1', name: 'VSKR & Associates', type: 'firm', icon: '⚖️' },
    { id: 'client1', name: 'Client Portal', type: 'client', icon: '🏢' }
  ]);

  const switchWorkspace = (workspace) => {
    setCurrentWorkspace(workspace);
  };

  return (
    <WorkspaceContext.Provider value={{
      currentWorkspace,
      workspaces,
      switchWorkspace
    }}>
      {children}
    </WorkspaceContext.Provider>
  );
};
